export interface IDate {
    date: string;
    timezone: string;
}

export function dateObjToDisplay(date: IDate) {

    const parsedDate = Date.parse(date.date);
    if (isNaN(parsedDate)) {
        return date.date;
    }
    const dt = new Date(parsedDate);
    return dt.toLocaleDateString() + ' @ ' + dt.toLocaleTimeString('nl-NL');
}

/**
 * https://stackoverflow.com/a/28559624
 * @param b64Data
 * @param contentType
 */
export function b64toBlob(b64Data: string, contentType: string): Blob {
    contentType = contentType || '';
    const sliceSize = 512;
    b64Data = b64Data.replace(/^[^,]+,/, '');
    b64Data = b64Data.replace(/\s/g, '');
    const byteCharacters = window.atob(b64Data);
    let byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
        const slice = byteCharacters.slice(offset, offset + sliceSize);

        const byteNumbers = new Array(slice.length);
        for (let i = 0; i < slice.length; i++) {
            byteNumbers[i] = slice.charCodeAt(i);
        }

        const byteArray = new Uint8Array(byteNumbers);
        byteArrays.push(byteArray);
    }

    return new Blob(byteArrays, {type: contentType});
}

export function getIconForFileType(fileExtension?: string) {
    if (!fileExtension) {
        return "mdi-file-document-outline";
    }
    switch (fileExtension) {
        case "xml":
            return "mdi-file-xml-box";
        case "gif":
            return "mdi-file-gif-box";
        case "png":
            return "mdi-file-png-box";
        case "jpg":
        case "jpeg":
            return "mdi-file-png-box";
        case "csv":
            return "mdi-file-delimited-outline";
        case "zip":
            return "mdi-folder-zip-outline";
        case "pdf":
            return "mdi-file-pdf-box";
        case "xsl":
        case "xslx":
            return "mdi-microsoft-excel";
        case "doc":
        case "docx":
            return "mdi-microsoft-word";
        default:
            return "mdi-file-document-outline";
    }

}